import { Component, OnInit } from "@angular/core";
import { StepsService } from "../../services/steps/steps.service";

@Component({
    selector: "ig-steps",
    templateUrl: "./steps.component.html",
    styleUrls: ["./steps.component.scss"],
})
export class StepsComponent implements OnInit {

    constructor(private stepsService: StepsService) {}

    ngOnInit() {}

    public get steps() {
        return this.stepsService.steps;
    }
}
